/**
 * 环境常量
 * 从 Vite 环境变量中获取
 */

// 当前环境
export const ENV = import.meta.env.VITE_ENV || 'development'

// 是否调试模式
export const IS_DEBUG = import.meta.env.VITE_DEBUG === 'true'

// 是否生产环境
export const IS_PROD = ENV === 'production'

// API 基础路径
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api'

// 应用标题
export const APP_TITLE = import.meta.env.VITE_APP_TITLE || '收单管理系统'

// CDN 地址（静态资源）
export const CDN_URL = import.meta.env.VITE_CDN_URL || ''

// 是否启用 CDN
export const IS_CDN = CDN_URL !== ''

// 基础路径
export const BASE_URL = import.meta.env.VITE_BASE_URL || '/'